import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _initializerDefineProperty from "@babel/runtime/helpers/initializerDefineProperty";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _inherits from "@babel/runtime/helpers/inherits";
import _applyDecoratedDescriptor from "@babel/runtime/helpers/applyDecoratedDescriptor";
import _initializerWarningHelper from "@babel/runtime/helpers/initializerWarningHelper";
var _class, _class2, _descriptor, _descriptor2;
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
import truncate from 'lodash/truncate';
import { action, observable } from 'mobx';
import { observer } from 'mobx-react';
import PropTypes from 'prop-types';
import React from 'react';
import ScrollMonitor from '../../../components/ScrollMonitor';
import { match } from '../../../utils/patternMatchUtil';
import { Message, MessageBubble, MessageDocument, CallMessageBubble, PromptMessageBubble } from '../../components/Conversation';
import { JobProgressionMessageBubble } from '../../components/Conversation/Message';

/**
 * Message container.
 */
var MessageContainer = observer(_class = (_class2 = /*#__PURE__*/function (_React$Component) {
  function MessageContainer() {
    var _this;
    _classCallCheck(this, MessageContainer);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _callSuper(this, MessageContainer, [].concat(args));
    _initializerDefineProperty(_this, "showDetails", _descriptor, _this);
    _initializerDefineProperty(_this, "toggleDetails", _descriptor2, _this);
    return _this;
  }
  _inherits(MessageContainer, _React$Component);
  return _createClass(MessageContainer, [{
    key: "render",
    value: function render() {
      var _this2 = this;
      var _this$props = this.props,
        message = _this$props.message,
        seenBy = _this$props.seenBy,
        group = _this$props.group,
        me = _this$props.me,
        onEnterViewport = _this$props.onEnterViewport,
        onDocumentClick = _this$props.onDocumentClick,
        onViewPrompt = _this$props.onViewPrompt,
        onViewRejectDraft = _this$props.onViewRejectDraft,
        onViewApproveDraft = _this$props.onViewApproveDraft,
        isReadOnly = _this$props.isReadOnly,
        onDelete = _this$props.onDelete;
      var isFirst = group.firstMessage.message === message;
      var isLast = group.lastMessage.message === message;
      var mine = group.sender === me;
      var groupSender = group.sender || {};
      var messageElement = /*#__PURE__*/React.createElement(Message, {
        id: message.id,
        mine: mine,
        avatar: !mine && isLast ? groupSender.avatar : '',
        seenBy: seenBy,
        name: !mine && isFirst && groupSender.displayName,
        receiptState: message.receiptState,
        onClick: message.type !== 'document' && this.toggleDetails || undefined,
        onDelete: onDelete,
        sentAt: this.showDetails && message.sentAt,
        type: message.type
      }, match(message.type, _defineProperty({
        TEXT: function TEXT() {
          return /*#__PURE__*/React.createElement(MessageBubble, null, message.textRendered);
        },
        SYSTEM: function SYSTEM() {
          return /*#__PURE__*/React.createElement(MessageBubble, {
            type: "admin"
          }, message.textRendered);
        },
        ADMIN: function ADMIN() {
          return /*#__PURE__*/React.createElement(MessageBubble, {
            type: "admin"
          }, message.textRendered);
        },
        NOTE: function NOTE() {
          return /*#__PURE__*/React.createElement(MessageBubble, {
            type: "note"
          }, message.textRendered);
        },
        TEAM_NOTE: function TEAM_NOTE() {
          return /*#__PURE__*/React.createElement(MessageBubble, {
            type: "note"
          }, message.textRendered);
        },
        ADMIN_NOTE: function ADMIN_NOTE() {
          return /*#__PURE__*/React.createElement(MessageBubble, {
            type: "note"
          }, message.textRendered);
        },
        EXTERNAL_REFERENCE: function EXTERNAL_REFERENCE() {
          switch (message.content.type) {
            case 'Prompt':
              {
                return /*#__PURE__*/React.createElement(PromptMessageBubble, {
                  message: message,
                  onViewPrompt: onViewPrompt
                });
              }
            case 'Progression':
              {
                return /*#__PURE__*/React.createElement(JobProgressionMessageBubble, {
                  message: message,
                  onViewRejectDraft: onViewRejectDraft,
                  onViewApproveDraft: onViewApproveDraft,
                  isReadOnly: isReadOnly
                });
              }
            case 'Assistant':
              return /*#__PURE__*/React.createElement(MessageBubble, null, message.textRendered);
            default:
              {
                return _this2._renderUnknown(message);
              }
          }
        },
        document: function document() {
          return /*#__PURE__*/React.createElement(MessageDocument, {
            title: message.document.title,
            subtitle: truncate(message.document.description, {
              length: 30
            }),
            fileName: message.document.latestVersion && message.document.latestVersion.files[0].fileName || '',
            onClick: onDocumentClick
          });
        },
        CALL: function CALL() {
          return /*#__PURE__*/React.createElement(CallMessageBubble, {
            message: message
          });
        }
      }, match.DEFAULT, function () {
        return _this2._renderUnknown(message);
      })));
      return !onEnterViewport ? messageElement : /*#__PURE__*/React.createElement(ScrollMonitor, {
        enterViewport: function enterViewport() {
          return onEnterViewport();
        }
      }, messageElement);
    }
  }, {
    key: "_renderUnknown",
    value: function _renderUnknown(message) {
      return /*#__PURE__*/React.createElement(MessageBubble, null, message.text);
    }
  }]);
}(React.Component), _descriptor = _applyDecoratedDescriptor(_class2.prototype, "showDetails", [observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return false;
  }
}), _descriptor2 = _applyDecoratedDescriptor(_class2.prototype, "toggleDetails", [action], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    var _this3 = this;
    return function () {
      _this3.showDetails = !_this3.showDetails;
    };
  }
}), _class2)) || _class;
MessageContainer.propTypes = {
  message: PropTypes.any,
  group: PropTypes.any,
  onEnterViewport: PropTypes.func,
  onDocumentClick: PropTypes.func,
  onDelete: PropTypes.func,
  name: PropTypes.any,
  me: PropTypes.any,
  seenBy: PropTypes.oneOfType([PropTypes.string, PropTypes.arrayOf(PropTypes.string)])
};
export default MessageContainer;
//# sourceMappingURL=MessageContainer.js.map
